// extracted by mini-css-extract-plugin
export default {"container":"TabsPanelDisplay_container__qKpph","infoContainer":"TabsPanelDisplay_infoContainer__v+GLH","attributeName":"TabsPanelDisplay_attributeName__MpN6E"};